export default "__VITE_ASSET__3$N6LoQ5__"